import { type Scope, createContextScope } from '@radix-ui/react-context'
import type { ChipsContext, ChipsProps, ChipsScopedProps } from './chips.types'

import { ChipsInput } from './components/chipsInput'
import { ChipsLabel } from './components/chipsLabel'
import { ChipsMultiple } from './components/chipsMultiple'
import { ChipsSingle } from './components/chipsSingle'

const DISPLAY_NAME = 'Chips'

const ChipsRoot = (props: ChipsScopedProps<ChipsProps>) => {
  const { size, children, disabled, __scopeChips, ...rest } = props

  return (
    <ChipsProvider
      {...props}
      size={size}
      disabled={disabled}
      scope={__scopeChips}
    >
      {children}
    </ChipsProvider>
  )
}

ChipsRoot.displayName = DISPLAY_NAME

/*
----------------------------------------------------------------
Scope Definition
----------------------------------------------------------------
*/

const [createChipsContext] = createContextScope(DISPLAY_NAME)

export const [ChipsProvider, useChipsContext]: readonly [
  ProviderType<ChipsContext>,
  (consumerName: string, scope: Scope) => ChipsContext,
] = createChipsContext<ChipsContext>(DISPLAY_NAME)

/*
----------------------------------------------------------------
Composition Export
----------------------------------------------------------------
*/

export const Chips = {
  Root: ChipsRoot,
  Single: ChipsSingle,
  Label: ChipsLabel,
  Input: ChipsInput,
  Multiple: ChipsMultiple,
}
